import { render, staticRenderFns } from "./payOrdersDY.vue?vue&type=template&id=0bea742b&scoped=true"
import script from "./payOrdersDY.vue?vue&type=script&lang=js"
export * from "./payOrdersDY.vue?vue&type=script&lang=js"
import style0 from "./payOrdersDY.vue?vue&type=style&index=0&id=0bea742b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea742b",
  null
  
)

export default component.exports